import { Component } from '@angular/core';
import { CriacaoContaCliente } from '@app/models/criacao-conta-cliente.model';
import { LoginService } from '@app/services/login.service';

@Component({
  selector: 'app-administrativo-clientes-formulario',
  templateUrl: './administrativo-clientes-formulario.component.html',
  styleUrls: ['./administrativo-clientes-formulario.component.scss']
})
export class AdministrativoClientesFormularioComponent {
  clientesCadastrados: CriacaoContaCliente[] = [];
  novoCliente: CriacaoContaCliente = new CriacaoContaCliente();
  aguardandoSolicitacao: boolean = false;
  horarioSolicitacao: string;
  horarioEstimado: string;

  constructor(private _loginService: LoginService) {
    this._atualizaHorarios();
  }

  private _atualizaHorarios() {
    let agora = new Date();
    this.horarioSolicitacao = agora.toISOString();
    agora.setMinutes(agora.getMinutes() + 15);
    this.horarioEstimado = agora.toISOString();
  }

  criar(): void {
    this._atualizaHorarios();
    this.aguardandoSolicitacao = true;
    this._loginService.cadastrarCliente(this.novoCliente).toPromise().then(
      () => {
        this.clientesCadastrados.push(this.novoCliente);
        this.novoCliente = new CriacaoContaCliente();
      },
      error => {
        console.error(error);
      }
    ).finally(() => this.aguardandoSolicitacao = false);
    
  }
}
